import { pick } from 'lodash-es';

import { buildColorRangeLegendRule } from './build-color-rule.js';
import type { RangeLegendColorMap } from '../types/internal.js';

export const getRangeLegendWithColorRules = (
  baseLegendColorMap: RangeLegendColorMap,
  colorRulesMap: ReturnType<typeof buildColorRangeLegendRule>,
) => {
  const legendColorMap: RangeLegendColorMap = new Map();

  baseLegendColorMap.forEach((value, key) => {
    const range = pick(key, ['from', 'to']);
    const colorRule = colorRulesMap?.for(key);
    legendColorMap.set(range, colorRule ?? value);
  });

  return legendColorMap;
};
